export default __webpack_public_path__ + "static/media/6a3c812cba523e678c39c59b9e260d5b1581620280619.3c8ff8fd.webp";